module.exports = __webpack_public_path__ + "img/donante-chrismas.014710ef.png";